/** Represent a month in a calendar year. Contains the weeks within the month. */
export class CalendarMonth {
    constructor(month, weeks) {
        this.date = month;
        this.weeks = weeks;
    }
}
//# sourceMappingURL=CalendarMonth.js.map